import { GetChildRoutes } from "@/entities/GetChildRoutes";
import { getSectionRouteName } from "@/helpers/routes/getSectionRouteName";

export const getChildRoutes: GetChildRoutes = routes => ({
  prefix,
  children = [],
  breadcrumbTitle,
}) => {
  return routes.map(route => {
    const routeName = route.name;
    const name = routeName
      ? getSectionRouteName({
          routeName,
          prefix,
        })
      : undefined;

    const mixedChildren = [
      ...children,
      ...(route.children ? route.children : []),
    ];

    if (!breadcrumbTitle) {
      return {
        ...route,
        name,
        children: mixedChildren,
      };
    }

    return {
      ...route,
      name,
      children: mixedChildren,
      meta: {
        ...route.meta,
        breadcrumb: {
          ...(route.meta?.breadcrumb ?? []),
          title: breadcrumbTitle,
        },
      },
    };
  });
};
